import { UITheme } from './UITheme';
import * as Phaser from 'phaser';
import { APP_VERSION_LABEL } from '../config/AppVersion';
import { createLogger } from '../utils/Logger';

const logger = createLogger('VersionLabel');

export function createVersionLabel(scene: Phaser.Scene): Phaser.GameObjects.Text | null {
  if (!APP_VERSION_LABEL || typeof APP_VERSION_LABEL !== 'string') {
    logger.debug('createVersionLabel:invalid-version-metadata', { label: APP_VERSION_LABEL });
    return null;
  }

  const label = scene.add.text(scene.scale.width - 16, scene.scale.height - 12, APP_VERSION_LABEL, {
    fontFamily: UITheme.body,
    fontSize: '14px',
    color: '#8fa5b5'
  });
  label.setName('app-version-label');
  label.setOrigin(1, 1);
  label.setDepth(20);
  return label;
}
